export default __webpack_public_path__ + "static/media/wcu-trend.67fccddc.png";